module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toctitle"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/06_9780813123042_foreword"
    }
  }, [_vm._v("Foreword: Collaborating with Coppola")]), _vm._v(" "), _c('i', [_vm._v("by Walter Murch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/07_9780813123042_acknowledgments"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/08_9780813123042_chronology"
    }
  }, [_vm._v("Chronology for Francis Ford Coppola")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/09_9780813123042_prologue"
    }
  }, [_vm._v("Prologue: Artist in an Industry")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/10_9780813123042_part1"
    }
  }, [_vm._v("Part One Hollywood Immigrant")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/11_9780813123042_chapter1"
    }
  }, [_vm._v("1  Point of Departure: The Early Films and Screenplays")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_9780813123042_chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2  Going Hollywood: "), _c('i', [_vm._v("You’re a Big Boy Now")]), _vm._v(" and "), _c('i', [_vm._v("Finian’s Rainbow")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_9780813123042_chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3  Nightmares at Noon: "), _c('i', [_vm._v("The Rain People")]), _vm._v(" and "), _c('i', [_vm._v("The Conversation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_9780813123042_part2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Two The Mature Moviemaker")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_9780813123042_chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4  In a Savage Land: "), _c('i', [_vm._v("The Godfather")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_9780813123042_chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5  Decline and Fall: "), _c('i', [_vm._v("The Godfather Part II")]), _vm._v(" and "), _c('i', [_vm._v("The Godfather Part III")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/17_9780813123042_chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6  The Unknown Soldiers: "), _c('i', [_vm._v("Apocalypse Now, Apocalypse Now Redux")]), _vm._v(", and "), _c('i', [_vm._v("Gardens of Stone")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/18_9780813123042_part3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Three Artist in an Industry")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/19_9780813123042_chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7  Exiled in Eden: "), _c('i', [_vm._v("One from the Heart")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/20_9780813123042_chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8  Growing Pains: "), _c('i', [_vm._v("The Outsiders")]), _vm._v(" and "), _c('i', [_vm._v("Rumble Fish")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/21_9780813123042_chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9  Night Life: "), _c('i', [_vm._v("The Cotton Club")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/22_9780813123042_part4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Four The Vintage Years")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/23_9780813123042_chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10  The Past as Present: "), _c('i', [_vm._v("Peggy Sue Got Married")]), _vm._v(" and “Rip Van Winkle”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/24_9780813123042_chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11  The Disenchanted: "), _c('i', [_vm._v("Tucker: The Man and His Dream")]), _vm._v(" and "), _c('i', [_vm._v("New York Stories")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/25_9780813123042_chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12  Fright Night: "), _c('i', [_vm._v("Bram Stoker’s Dracula")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/26_9780813123042_chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13  The Vanishing Hero: "), _c('i', [_vm._v("The Rainmaker")]), _vm._v(" and "), _c('i', [_vm._v("Jack")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/27_9780813123042_epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue: The State of the Artist in the Industry Today")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/28_9780813123042_notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/29_9780813123042_bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selected Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/30_9780813123042_filmography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Filmography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/31_9780813123042_index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/17_9780813123042_chapter6#page_172-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Photographs follow page")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ad4dedd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/05_9780813123042_content.vue
// module id = 69
// module chunks = 0